<template>
  <div class="problem-table" :class="{ 'upload-data': uploadData }">
    <circle-loader v-if="uploadData" size="xlarge" :indeterminate="true" />

    <div class="problem-table__header">
      <div class="filters">
        <div class="row">
          <div class="col-2">
            <div class="form-data">
              <div v-if="dateRangeDate && dateRangeDate[0] && dateRangeDate[1]" class="upper-label">Период</div>
              <date-picker
                v-model="dateRangeDate"
                :range="dateRange"
                :class="'date-range-picker'"
                lang="ru"
                range-separator="-"
                :clearable="false"
                @change="keymonitor($event)"
              />
              <div class="after-input" />
            </div>
          </div>
          <div class="col-2">
            <form-select
              :input-model="defaultStatus"
              :input-options="inputOptions"
              :enable-color-info="true"
              :keymonitor="keymonitor"
              fieldname="defaultStatus"
              label="Статус"
              @update="updateData"
            />
          </div>
          <div class="col-2">
            <form-select
              :input-model="defaultPrioritet"
              :input-options="prioritetOptions"
              :enable-color-info="true"
              :keymonitor="keymonitor"
              fieldname="defaultPrioritet"
              label="Приоритет"
              @update="updateData"
            />
          </div>
          <div class="col-2">
            <form-select
              :input-model="defaultObjectType"
              :input-options="objectTypeOptions"
              :keymonitor="keymonitor"
              fieldname="defaultObjectType"
              label="Тип объекта"
              @update="updateData"
            />
          </div>
        </div>
      </div>
      <div class="table-header">
        <div class="table-header__titles">
          <div class="up">Всего</div>
          <div class="down">{{ problemsResultsCount }}</div>
        </div>

        <table-paginator :max-count="problemsResultsCount" :page-size="15" />

        <i class="spacer" />
      </div>
    </div>

    <div :class="{ 'no-result': fetchFinished && problemsData.length === 0 }" class="problem-table__content">
      <template v-if="fetchFinished && problemsData.length === 0">
        <div>Нет ни одной записи</div>
      </template>
      <div
        v-for="problem in problemsData"
        :key="`problem-list-item-${problem.id}`"
        class="content-block"
        @click="toProblemUpdate(problem)"
      >
        <div class="row">
          <div class="col-6">
            <div class="problem-title">Проблема {{ problem.id }}</div>
            <div class="col-12">
              <p>{{ problemTypes[problem.type] }}</p>
            </div>
            <div class="problem-info">
              <div class="col-4">
                <div class="info-form">
                  <div :class="problem.status" class="info-form__content status">{{ getStatus(problem.status) }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="info-form">
                  <div class="info-form__title">Приоритет</div>
                  <div :class="'priority__' + problem.priority" class="info-form__content priority">
                    {{ getPriority(problem.priority) }}
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="info-form">
                  <div class="info-form__title">Создана</div>
                  <div class="info-form__content">{{ getDate(problem.created_at) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-8">
                <div class="info-form">
                  <div class="info-form__title">Тип объекта</div>
                  <div class="info-form__content">{{ getObjectType(problem.object_type) }}</div>
                </div>
                <div class="info-form">
                  <div class="info-form__title">Идентификатор объекта</div>
                  <div class="info-form__content">№ {{ problem.identifier }}</div>
                </div>
                <div class="info-form">
                  <div class="info-form__title">Адрес</div>
                  <div :title="problem.location" class="info-form__content">{{ problem.location }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="attachments-list">
                  <span v-if="problem.attachments.length === 0">Без вложений</span>
                  <span v-if="problem.attachments.length > 0">{{ getAttachmentsData(problem.attachments) }}</span>
                  <div class="images">
                    <template v-for="(image, index) in problem.attachments">
                      <img
                        v-if="image.kind === 'IMAGE'"
                        :key="`problem-${problem.id}-attachment-${index}`"
                        :src="image.url"
                        alt=""
                      />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import DatePicker from "vue2-datepicker";
import axios from "axios";

import FormSelect from "../../../../components/forms/FormSelect";
import AsyncTablePaginator from "../../../../components/AsyncTablePaginator";
import CircleLoader from "../../../../components/CircleLoader";

export default {
  name: "ProblemsTable",
  components: {
    FormSelect,
    TablePaginator: AsyncTablePaginator,
    DatePicker,
    CircleLoader
  },
  data() {
    return {
      dateRangeDate: "",
      dateRange: true,
      uploadData: false,
      fetchFinished: false,
      defaultStatus: "ALL",
      inputOptions: [
        {
          text: "Все",
          value: "ALL"
        },
        {
          text: "Открыта",
          value: "OPEN"
        },
        {
          text: "В работе",
          value: "IN_WORK"
        },
        {
          text: "Решена",
          value: "RESOLVED"
        }
      ],
      defaultPrioritet: "ALL",
      prioritetOptions: [
        {
          text: "Все",
          value: "ALL"
        },
        {
          text: "Обычный",
          value: "USUAL",
          color: "USUAL"
        },
        {
          text: "Высокий",
          value: "HIGH",
          color: "HIGH"
        },
        {
          text: "Низкий",
          value: "LOW",
          color: "LOW"
        }
      ],
      defaultObjectType: "ALL",
      objectTypeOptions: [],
      priorityDic: {
        USUAL: "Обычный"
      },
      statusDic: {
        OPEN: "ОТКРЫТА"
      },
      objectTypeDic: {
        SPECIAL_WASTE_AREA: "Специальные площадки для КГО",
        CONTAINER_WASTE_AREA: "Контейнерные площадки",
        COLLECTION_WASTE_AREA: "Пункты накопления вторсырья",
        CHAMBER_WASTE_AREA: "Мусороприемные камеры",
        CONTRACT: "Договор"
      }
    };
  },
  computed: {
    ...mapState(["problemsData", "problemsResultsCount", "problemTypes", "problemObjectTypes"]),
    currentPage() {
      return this.$store.getters["hashManager/getRouteOption"]({ route: this.$route, option: "page" }) || 1;
    },
    pageOptions() {
      return this.$store.getters["hashManager/getRouteOptions"](this.$route);
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (newValue === oldValue) return;

      axios.cancel("problems");
      this.uploadData = true;

      this.getProblems({
        params: {
          page: newValue
        }
      }).then(response => {
        if (response && response.status && response.status === 200) {
          this.uploadData = false;
        } else {
          if (axios.isCancel(response) && !axios.hasOpenRequest("problems")) {
            this.uploadData = false;
          }
        }
      });
    }
  },
  mounted() {
    const objectTypeOptions = [];

    objectTypeOptions.push({ text: "Все", value: "ALL" });

    Object.keys(this.problemObjectTypes).map(el => {
      const obj = {
        text: this.problemObjectTypes[el],
        value: el
      };
      objectTypeOptions.push(obj);
    });

    this.objectTypeOptions = objectTypeOptions;

    if (this.problemsData.length === 0) {
      axios.cancel("problems");
      this.uploadData = true;

      this.getProblems({ params: { page: this.currentPage } }).then(response => {
        if (response && response.status && response.status === 200) {
          this.uploadData = false;
          this.fetchFinished = true;
        } else {
          if (axios.isCancel(response) && !axios.hasOpenRequest("problems")) {
            this.uploadData = false;
            this.fetchFinished = true;
          }
        }
      });
    }

    this.$root.$emit("onChangeHeader", {
      upTitle: "Аналитика",
      mainTitle: "Проблемы"
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "UpdateProblem" || to.name === "ViewProblem") {
      next();
    } else {
      this.updateRouteOptions({ route: this.$route, options: { ...this.pageOptions, page: 1 } });
      next();
    }
  },
  beforeDestroy() {
    axios.cancel("problems");

    this.setProblems([]);
  },
  methods: {
    ...mapActions(["getProblems"]),
    ...mapMutations(["setProblems"]),
    ...mapMutations("hashManager", ["updateRouteOptions"]),
    getAttachmentsData(attachments) {
      let fileCount = 0;
      let photoCount = 0;
      let content = "";

      attachments.map(el => {
        if (el.kind === "IMAGE") {
          photoCount += 1;
        } else {
          fileCount += 1;
        }
        return el;
      });
      if (photoCount > 0) {
        content += `${photoCount} фото`;
      }
      if (fileCount > 0) {
        if (photoCount > 0) {
          content += " - ";
        }
        if (fileCount === 1) {
          content += `${fileCount} документ`;
        } else if (fileCount < 5) {
          content += `${fileCount} документа`;
        } else {
          content += `${fileCount} документов`;
        }
      }
      return content;
    },
    toProblemUpdate(problem) {
      this.$router.push({
        name: "UpdateProblem",
        params: { problemId: problem.id }
      });
    },
    getDate(date) {
      if (date) {
        return new Date(date).toLocaleDateString("ru");
      }
      return "N/O";
    },
    getPriority(priority) {
      return this.prioritetOptions.find(el => el.value === priority).text;
    },
    getStatus(status) {
      const statusObj = this.inputOptions.find(el => el.value === status);

      return statusObj ? statusObj.text : "";
    },
    getObjectType(type) {
      return this.problemObjectTypes[type];
    },
    getIsoDate(date) {
      const d = new Date(date);

      return `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)}`;
    },
    keymonitor() {
      const params = {};

      if (this.defaultStatus !== "ALL") {
        params.status = this.defaultStatus;
      }
      if (this.defaultPrioritet !== "ALL") {
        params.priority = this.defaultPrioritet;
      }
      if (this.defaultObjectType !== "ALL") {
        params.object_type = this.defaultObjectType;
      }
      if (this.dateRangeDate && this.dateRangeDate[0] && this.dateRangeDate[1]) {
        params.created_at_before = this.getIsoDate(this.dateRangeDate[1]);
        params.created_at_after = this.getIsoDate(this.dateRangeDate[0]);
      }

      axios.cancel("problems");
      this.uploadData = true;

      this.getProblems({ params }).then(response => {
        if (response && response.status && response.status === 200) {
          this.uploadData = false;
          this.fetchFinished = true;
        } else {
          if (axios.isCancel(response) && !axios.hasOpenRequest("problems")) {
            this.uploadData = false;
            this.fetchFinished = true;
          }
        }
      });
    },
    updateData(data) {
      const target = data.fieldname.split(".");
      const dataType = typeof data.value === "undefined";

      if (target.length === 1) {
        this[target[0]] = dataType ? null : data.value;
      }
    }
  }
};
</script>
